<template>
  <v-dialog :value="value" width="500" @input="onClose">
    <div class="deviation-dialog">
      <div class="deviation-dialog-title">{{ $t('Approve deviation') }}</div>
      <div class="deviation-dialog-sub-title">{{ $t('Note (optional)') }}</div>
      <textarea
        class="deviation-dialog-textarea"
        v-model="note"
        :placeholder="`${$t('Optional text')}...`"
      >

        </textarea>
      <div class="deviation-dialog-button-box">
        <v-btn
          color="#ddd"
          class="mr-4"
          elevation="0"
          @click="onClose"
        >{{$t('Cancel')}}</v-btn>
        <v-btn
          color="primary"
          elevation="0"
          @click="approveDeviation(eventId)"
        >{{$t('Confirm')}}</v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>

export default {
  name: 'DeviationApprovalModal',
  props: {
    value: {
      type: Boolean,
      required: true,
      default: false,
    },
    eventId: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      note: null,
    };
  },
  methods: {
    onClose() {
      this.$emit('input', false);
      this.note = null;
    },
    approveDeviation(id) {
      this.$emit('input', false);
      // eslint-disable-next-line
      const note = this.note;
      this.note = null;

      const deviationPromises = [];
      deviationPromises.push(this.$Event.api().approveDeviation(id).then(() => {
        this.$Event.update({
          where: id,
          data: {
            approvedBy: {
              name: this.$store.state.authentication.user.fullName
                ? this.$store.state.authentication.user.fullName
                : this.$store.state.authentication.user.username,
            },
          },
        });
      }));

      if (note?.length) {
        deviationPromises.push(this.$Event.api().addNote(id, note));
        this.$toast(this.$t('Approving deviation with note'), { id: 'deviationToast', type: 'loading' });
      } else {
        this.$toast(this.$t('Approving deviation'), { id: 'deviationToast', type: 'loading' });
      }

      Promise.all(deviationPromises).then(async () => {
        if (note) {
          const event = this.$Event.find(id);
          const newNotes = await this.$Event.api().getNotes(id);
          this.$Event.insertOrUpdate({
            data: [
              {
                ...event,
                notes: newNotes.response.data,
              },
            ],
          });
          this.$updateToast('deviationToast', { message: this.$t('Deviation approved with note'), type: 'loadingSuccess' });
        } else {
          this.$updateToast('deviationToast', { message: this.$t('Deviation approved'), type: 'loadingSuccess' });
        }
        this.$emit('deviationApproved');
      }).catch(() => {
        this.$removeToast('deviationToast');
      });
    },
  },
};
</script>

<style scoped lang="scss">

  .deviation-dialog {
    width: 100%;
    min-height: 100px;
    background-color: #fff;
    border-radius: 8px;
    padding: 16px 32px;
  }

  .deviation-dialog-title {
    font-size: 22px;
    font-weight: 600;
    color: #363636;
    margin-bottom: 4px;
  }

  .deviation-dialog-sub-title {
    font-size: 12px;
    color: #aaa;
    margin-bottom: 8px;
  }

  .deviation-dialog-textarea {
    width: 100%;
    background-color: #f4f4f4;
    height: 140px;
    resize: none;
    border-radius: 6px;
    padding: 12px;

  &:focus {
     outline: none;
   }
  }

  .deviation-dialog-button-box {
    width: 100%;
    display: flex;
    justify-content: flex-end;
  }
</style>
